
























































interface Subject {
    id: number;
    no: number;
    text: string;
}
interface contentTableList {
    income: string;
    period: string;
}
import AccountingSystem from "@/data/AccountingSystem";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
 
@Component
export default class IncomeReminder extends Vue {
    @Prop({ type: Object })
    accountBook?: AccountBookList.AccountBook;
    income: string = "500万";
    subjectList: Subject[] = [];
    contentTableList: contentTableList[] = [];
    subjectVal: number = 1;


    mounted() {
        // 初始选择科目
        if (this.accountBook) {
            if (this.accountBook.accountingSystem === AccountingSystem.thirteenRule) {
                this.subjectList = [
                    {
                        id: 1,
                        no: 5001,
                        text: "主营业务收入"
                    },
                    {
                        id: 2,
                        no: 5051,
                        text: "其他业务收入"
                    }
                ];
            } else {
                this.subjectList = [
                    {
                        id: 1,
                        no: 6001,
                        text: "主营业务收入"
                    },
                    {
                        id: 2,
                        no: 6051,
                        text: "其他业务收入"
                    }
                ];
            }
        }
        // 初始获取第一个数据的焦点
        this.subjectVal = this.subjectList[0].id;
        this.getList(this.$utils.focusFirstInput);
    }

    // 改变表格数据
    preservation() {
        if (this.accountBook) {
            Vue.axios
                .post(
                    `history/income?accountBookId=${
                        this.accountBook.id
                    }&incomeType=${this.subjectVal}`,
                    this.contentTableList
                )
                .then(res => {
                    this.getList();
                });
        }
    }

    // 获取表格数据
    getList(then?: Function) {
        if (this.accountBook) {
            Vue.axios
                .get(
                    `history/income?accountBookId=${
                        this.accountBook.id
                    }&incomeType=${this.subjectVal}`
                )
                .then(res => {
                    this.contentTableList = res.data;
                    if (then) then();
                });
        }
    }

    // 选中科目
    subjectChange() {
        this.getList();
    }
    // focus input
    editSomething(el: any) {
        el.currentTarget.select();
    }

    close() {
        this.$emit("close");
    }
}
